enum KWitt_WebCalendar_UrlParameters {
    //"adminCenterTarget" = "target",
    "action"="action",
    "item" = "evt",
    "dateStart" = "dS",
    "dateEnd" = "dE",
    "intervalType" = "view",
    "intervalSteps" = "step"


}
(globalThis as any).KWitt_WebCalendar_UrlParameters = KWitt_WebCalendar_UrlParameters; // (mds A11) seed runtime value for cross-file bare refs
